import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import translations from 'constants/translations';
import { isLoginAsSelector } from 'store/auth/selectors';
import { currentAccountSelector, isSuperAdminSelector, userNameSelector, userSelector } from 'store/user/selectors';

import source from './source';

export function useUserGuiding() {
  useEffect(() => {
    const isProductionEnv = process.env.REACT_APP_ENV === 'production';
    const notPdfView = localStorage.getItem('pdfPreview') !== 'true';

    // for testing purpose only
    const needToForceLoad = localStorage.getItem('__SP_LOAD_USERGUIDING') === '1';

    const needToLoadScript = notPdfView && (isProductionEnv || needToForceLoad);

    if (needToLoadScript) {
      const script = document.createElement('script');
      script.innerHTML = source;

      document.head.appendChild(script);
    }
  }, []);

  useIdentification();
}

function useIdentification() {
  const isSuperAdmin = useSelector(isSuperAdminSelector);
  const isOverriding = useSelector(isLoginAsSelector);
  const account = useSelector(currentAccountSelector);
  const user = useSelector(userSelector);
  const name = useSelector(userNameSelector);
  // @ts-ignore
  const accountType = translations.accountType[account.type];
  const trialEndDate =
    account.plan === 'trial' && account.trialEnd > 0 ? new Date(account.trialEnd).toISOString() : undefined;

  useEffect(() => {
    if (account && !isOverriding) {
      initUser([user.id, account.id].join('_'), {
        email: user.email,
        name,
        first_name: user.firstName,
        last_name: user.lastName,
        created_at: user.createdAt,
        account_type: accountType,
        role: account.owner ? 'primary' : 'sub',
        is_paid: account.paid,
        plan: account.plan,
        trial_end_date: trialEndDate,
        company_name: isSuperAdmin ? 'SP Super Admins' : account.companyName,
        company_created_at: account.createdAt,
      });
    }
  }, [user, name, account, accountType, isOverriding, isSuperAdmin, trialEndDate]);
}

function initUser(id: string, attributes: any) {
  if ('userGuiding' in window) {
    window.userGuiding.identify(id, { ...attributes });
  }
}
